import React, { useState, useEffect, useRef } from "react";
import { Delete } from "@material-ui/icons";
import { Download } from "@material-ui/icons";
import {
  Grid,
  TextField,
  Autocomplete,
  Typography,
  Backdrop,
  CircularProgress,
  IconButton,
  Button,
  FormControl,
  Box,
  InputAdornment,
} from "@material-ui/core";
import CardHeader from "../StyledComponents/Card/CardHeader";
import CardText from "../StyledComponents/Card/CardText";
import CardBody from "../StyledComponents/Card/CardBody";
import { makeStyles } from "@material-ui/styles";
import { ArrowBack } from "@material-ui/icons";
import moment from "moment";
import getParameterByName from "../Functions/functions";
import { useNavigate } from "react-router-dom";
import { dashboardStyle } from "../views/Invoices/Components/InvoiceDetails/style";
import CustomSnackbar from "../CustomSnackbar";
import Card from "../StyledComponents/Card/Card";
import { getUserRoles } from "../views/Home/actions";
import InvoiceTextField from "../views/Invoices/Components/InvoiceDetails/InvoiceTextFields";
import InvoiceDetailTextField from "../views/Invoices/Components/InvoiceDetails/InvoiceDetailTextFields";
import {
  clearState,
  getCommentsByInvoiceId,
  getInvoiceByInvoiceIdAndRoleId,
  getVendorByPO,
  updateIPInvoice,
  getAllInvoiceDetailByInvoiceId,
  vendorTaxDetailForCnic,
  changeInvoiceStatus,
  getRefrenceDataList,
  uploadAdditioalDocumentFile,
  LoamPutInvoice,
  getBatchInvoiceDetails,
} from "../views/Invoices/actions";
import { GetBatchInvoiceDetailsWithname } from "../views/Invoices/ProcessInvoice/actions";
import AttachmentsCover from "../components/Attachments/AttachmentsCover";
import GL_Table_ProcessInvoice from "../views/Invoices/NewInvoice/Tables/GL_Table_ProcessInvoice";
import downloadAttachments from "../Functions/downloadAttachments";
import ConfirmationModal from "../components/ConfirmModal/ConfirmationModal";
import InvoiceGuideLine from "../views/Invoices/NewInvoice/InvoiceGuidLines/InvoiceGuideLine";
import TaxDetail from "../views/Invoices/Components/TaxDetails/TaxDetails";
import TaxDetailTextField from "../views/Invoices/Components/TaxDetails/TaxDetailTextField";
import TaxTable from "../views/Invoices/NewInvoice/Tables/Tax_Table";
import UsersByRole from "../views/Invoices/NewInvoice/Dropdowns/UsersByRole";
import GL_Table from "../views/Invoices/NewInvoice/Tables/GL_Table";
import InvoiceCheckboxes from "../views/Invoices/Components/InvoiceDetails/InvoiceCheckboxes";
import InvoiceRadioButtons from "../views/Invoices/Components/InvoiceDetails/InvoiceRadiobuttons";
import Heading from "../StyledComponents/Heading/Heading";
import CommentHistory from "../views/Invoices/NewInvoice/Tables/CommentHistory";
import ExpenseTable from "../views/Invoices/NewInvoice/Tables/GL_Table";

const useStyles = makeStyles(dashboardStyle);
const LoamDetail = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const [poBasedState, setPoBasedState] = useState("PO");
  const invoiceId = getParameterByName("invoiceId");
  const roleId = getParameterByName("roleId");
  const roleName = getParameterByName("roleName");
  const vendorCode = getParameterByName("vendorCode");
  const edit = getParameterByName("edit");

  const invoicePayload = {
    Invoice_id: invoiceId,
    Vendor_Code: vendorCode,
  };
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [attachmentFile_UI, setAttchmentFile_UI] = useState([]);
  const [physicalOrEInvoice, setPhysicalOrEInvoice] = useState("Physical");
  const [attachInvoiceLoading, setAttachInvoiceLoading] = useState(false);
  const [rolesLoading, setRolesLoading] = useState(false);
  const [attachmentURLList, setAttachmentURLList] = useState([]);
  const [roles, setRoles] = useState([]);
  const [gLAccountTotal, setGLAccountTotal] = useState(0);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [attachmentURL, setAttachmentURL] = useState("");
  const [confirmationMessage, setConfirmationMessage] = useState("");
  const [statusForPayload, setStatusForPayload] = useState("");
  const [openInvoiceGuideLine, setOpenInvoiceGuideLine] = useState(false);
  const role = {
    roleId: roleId,
    roleName: roleName,
  };
  const [disabled, setDisabled] = useState(false);
  const additionalAttachmentRef = useRef(null);
  const invoice_attachmentRef = useRef(null);
  const [selectedRole, setSelectedRole] = useState(
    role ? { roleName: role?.roleName } : ""
  );
  const [formState, setFormState] = useState({
    delv_Note_No: "",
    courier_Company: "",
    courier_Tracking_No: "",
    created_On: new Date(),
    updated_By: "",
    updated_On: new Date(),
    comments: "",
    po_Date: "",
    plant_Code: "",
    taxCard_List: [],
    invoice_Accounts_list: [],
    invoice_id: invoicePayload?.Invoice_id,
    additionalDocs: [],
    invoice_Accounts: [
      // {
      // //   accountId: 0,
      // //   invoice_Id: 0,
      // //   glAccount: " ",
      // //   costCenter: " ",
      // //   accountType: " ",
      // //   amount: 0,
      // //   costCenterOwner: " ",
      // //   stCode: " ",
      // //   order: " ",
      // //   profitCenter: " ",
      // //   wbsElement: " ",
      // //   created_By: " ",
      // //   created_On: "2022-12-08T10:26:43.808Z",
      // //   updated_By: " ",
      // //   updated_On: "2022-12-08T10:26:43.808Z",
      // //   fixedAsset: " ",
      // //   tType: " ",
      // //   description: " ",
      // //   expenseDate: " ",
      // //   horizonId: " ",
      // //   department: " ",
      // //   vendorCode: " "
      // }
    ],
    isReject: false,
    createdBy: " ",
    file_name: "",
    quantity: "",
    charge_Account: "",
    cost_Center: "",
    asset_No: "",
    dept_coordinator: "",
    loam_approver: "",
    buyer: "",
    prInitiator: "",
    taxTeam: "",
    paymentTerm: "",
    invoiceDocURL: "",
    isSubmittedByVendor: true,
    supervisorLevel: "",
    sodReviewer: "",
    dcReviewer: "",
    loamReviewer: "",
    supervisorReviewer: "",
    logisticsTeam: "",
    logisticsReviewer: "",
    reviewer1: "",
    reviewer2: "",
    pcdvSegment: "",
    pcdvLocation: "",
    invoiceLocation: "",
    employeeCode: "",
    vP_InvoiceId: 0,

    isInitiator: false,
    isDeptCordinator: false,
    isHR: false,
    isPCDV: false, // EFDV initiator
    isVPPayment: false,
    isVFPayment: false,
    isSubmittedByVendor: false,
    isImport: false,
    isLogistics: false,
    submission_Date: moment().format("YYYY-MM-DD"),
    pO_Based: true,
    isPSID: false,
    psid: "",
    urgent: false,
    skipTaxStep: false,

    ntn: "",
    salesTaxCode: "",
    salesTaxAmount: "",
    calculateTax: true,
    eInvoice: true,

    cheque_No: "",
    invoice_Date: "",
    invoice_Id: 0,
    grn_No: "",
    pO_No: "",
    barcode_No: "",
    demandType: "",
    invoice_Type: "",
    invoice_No: "",
    invoiceCategory: "",
    invoice_Desc: "",
    invoice_Amount: "",
    final_Invoice_Amount: "",
    dept_coordinator: "",
    irUser: "",
    ipUser: "",
    taxTeam: "",
    vendor_Code: "",
    vendor_Name: "",
    invoice_Date: "",
    lineManager: "",
    directorHR: "",
    sharedServices: "",
    invoice_attachment: "",
    additionalDocIds: "", // paths
    comments: "",
    due_Date: new Date(),

    additionalDocIds_array: [], // additional documents in array
    // for Payment detail
    invoice_Payment: {
      inv_Payment_Id: 0,
      invoice_Id: 0,
      postingKey: "",
      sglInd: "",
      tType: "",
      paymentTerms: "",
      paymentDays: "",
      paymentMethod: "",
      paymentMethSupp: "",
      individualPayee: false,
      account: "",
      amount: 0,
      taxAmount: 0,
      dueOn: "",
      taxCode: "",
      description: "",
      order: "",
      costCenter: "",
      wbsElement: "",
      profitCenter: "",
      createdBy: "",
      createdDate: new Date(),
    },
    // Tax Table data
    invoice_TaxDetails: [
      {
        taxId: 0,
        invoice_Id: 0,
        taxType: "",
        taxCode: "",
        amount: "",
        comments: "",
        created_By: "",
        created_On: new Date(),
        updated_By: "",
        updated_On: new Date(),
        taxCardId: 0,
      },
    ],
    // G/L Account detail.
    invoice_Accounts: [
      {
        accountId: 0,
        invoice_Id: 0,
        glAccount: "",
        costCenter: "",
        accountType: "",
        amount: 0,
        costCenterOwner: "",
        stCode: "",
        order: "",
        profitCenter: "",
        wbsElement: "",
        created_By: "",
        created_On: new Date(),
        updated_By: "",
        updated_On: new Date(),
        fixedAsset: "",
        tType: "",
        description: "",
        expenseDate: "",
        horizonId: "",
        department: "",
        vendorCode: "",
      },
    ],
    // PO Table Detail
    // "pO_Details" this keyword is used acctualy on backend, before hit the api it changes
    invoicePORef_List: [
      // we use this keyword due to reuse the PODetail table component.
      {
        poItem: "", //  item #
        poNumber: "", // poNumber
        refDoc: "", // GRN No
        quantity: "", // GRN quantity
        val_Loccur: "", // GRN amount
        invoicE_QTY: "", //  consumed quantity
        invoicE_VAL: 0, // consumed Amount
        inpuT_QTY: "", //  invoice QTY
        inpuT_VAL: "", //  Invoice amount
        currency: "", // currency
      },
    ],
    verified: false,
  });
  const [commentsList, setCommentsList] = useState([]);
  const [commentsLoading, setCommentsLoading] = useState(false);
  const [multipleData, setMultipleData] = useState({
    glAccount: [],
    paymentDetail: [],
    paymentMethod: [],
    paymentMethSupp: [],
    poData: [],
    vendorTaxDetail: [],
    invoice_Type: [],
  });

  const [newFormState, setNewFormState] = useState({
    isInitiator: false,
    isDeptCordinator: false,
    isHR: false,
    taxCard_List: [],
    invoice_Accounts_list: [],
    isPCDV: false, // EFDV initiator
    isVPPayment: false,
    isVFPayment: false,
    isSubmittedByVendor: false,
    isImport: false,
    isLogistics: false,
    submission_Date: moment().format("YYYY-MM-DD"),
    pO_Based: true,
    isPSID: false,
    psid: "",
    urgent: false,
    skipTaxStep: false,
    invoice_id: invoicePayload?.Invoice_id,
    additionalDocs: [],
    comments: "",
    invoice_Accounts: [
      // {
      // //   accountId: 0,
      // //   invoice_Id: 0,
      // //   glAccount: " ",
      // //   costCenter: " ",
      // //   accountType: " ",
      // //   amount: 0,
      // //   costCenterOwner: " ",
      // //   stCode: " ",
      // //   order: " ",
      // //   profitCenter: " ",
      // //   wbsElement: " ",
      // //   created_By: " ",
      // //   created_On: "2022-12-08T10:26:43.808Z",
      // //   updated_By: " ",
      // //   updated_On: "2022-12-08T10:26:43.808Z",
      // //   fixedAsset: " ",
      // //   tType: " ",
      // //   description: " ",
      // //   expenseDate: " ",
      // //   horizonId: " ",
      // //   department: " ",
      // //   vendorCode: " "
      // }
    ],
    isReject: false,
    createdBy: " ",
    // LogisticInvoices: false,
    // VendorPrePayment: false,
    // VendorFinancingPayment: false,
    grn_No: "",
    pO_No: "",
    barcode_No: "",
    demandType: "",
    invoice_Type: "",
    invoice_No: "",
    invoiceCategory: "",
    invoice_Desc: "",
    invoice_Amount: "",
    final_Invoice_Amount: "",
    dept_coordinator: "",
    irUser: "",
    ipUser: "",
    taxTeam: "",
    vendor_Code: "",
    vendor_Name: "",
    invoice_Date: "",
    lineManager: "",
    directorHR: "",
    sharedServices: "",
    invoice_attachment: "",
    additionalDocIds: "", // paths
    comments: "",

    additionalDocIds_array: [], // additional documents in array

    due_Date: "",

    cnic: "",
    ntn: "",
    salesTaxCode: "",
    salesTaxAmount: "",
    calculateTax: true,
    eInvoice: true,

    // for Payment detail
    invoice_Payment: {
      inv_Payment_Id: 0,
      invoice_Id: 0,
      postingKey: "",
      sglInd: "",
      tType: "",
      paymentTerms: "",
      paymentDays: "",
      paymentMethod: "",
      paymentMethSupp: "",
      individualPayee: false,
      account: "",
      amount: 0,
      taxAmount: 0,
      dueOn: "",
      taxCode: "",
      description: "",
      order: "",
      costCenter: "",
      wbsElement: "",
      profitCenter: "",
      createdBy: "",
      createdDate: new Date(),
    },

    // Tax Table
    invoice_TaxDetails: [
      {
        taxId: 0,
        invoice_Id: 0,
        taxType: "",
        taxCode: "",
        amount: "",
        comments: "",
        created_By: "",
        created_On: new Date(),
        updated_By: "",
        updated_On: new Date(),
        taxCardId: 0,
      },
    ],
    // G/L Account detail.
    invoice_Accounts: [
      {
        accountId: 0,
        invoice_Id: 0,
        glAccount: "",
        costCenter: "",
        accountType: "", // D/C (debit/ credit)
        amount: 0,
        costCenterOwner: "",
        stCode: "",
        order: "",
        profitCenter: "",
        wbsElement: "",
        created_By: "",
        created_On: new Date(),
        updated_By: "",
        updated_On: new Date(),
        fixedAsset: "",
        tType: "",
        description: "",
        expenseDate: "",
        horizonId: "",
        department: "",
        vendorCode: "",
      },
    ],
    // PO Table Detail
    // "pO_Details" this keyword is used acctualy on backend, before hit the api it changes
    invoicePORef_List: [
      // we use this keyword due to reuse the PODetail table component.
      // {
      //   poItem: "", //  item #
      //   poNumber: "", // poNumber
      //   refDoc: "", // GRN No
      //   quantity: "", // GRN quantity
      //   val_Loccur: "", // GRN amount
      //   invoicE_QTY: "", //  consumed quantity
      //   invoicE_VAL: 0, // consumed Amount
      //   inpuT_QTY: "", //  invoice QTY
      //   inpuT_VAL: "", //  Invoice amount
      //   currency: "", // currency
      // },
    ],

    verified: false,
  });

  const showVendorAndPO_NumberForImport = () => {
    let show = selectedRole?.roleName === "Import" ? true : false;
    if (
      selectedRole?.roleName === "Import" &&
      formState.demandType === "Deposit"
    ) {
      show = false;
    }

    return show;
  };
  useEffect(() => {
    let filterd_data = [];
    if (formState?.additionalDocIds?.length > 0) {
      filterd_data = formState.additionalDocIds.filter((e) => Number(e) !== 0);
    }

    setAttachmentURLList((pre) => [
      formState?.invoice_attachment,
      ...filterd_data,
    ]);
    if (formState?.invoice_attachment) {
      setAttachmentURL(formState?.invoice_attachment);
    } else {
      setAttachmentURL(formState?.additionalDocIds[0]);
    }
  }, [formState?.invoice_attachment, formState?.additionalDocIds]);

  useEffect(() => {
    if (formState.invoice_Id) {
      if (formState.pO_Based) {
        setPoBasedState("PO");
      } else {
        setPoBasedState("Non-PO");
      }
    }
  }, [formState.invoice_Id]);
  const showAttachmentsHandler = (attachment_URL) => {
    setAttachmentURL(attachment_URL);
  };
  const changeHandler = (e) => {
    const { name, value } = e.target;
    setNewFormState((newFormState) => ({
      ...newFormState,
      [name]: value,
    }));

    if (name === "pO_No") {
      getVendorByPO(value, "vendor_Code", setNewFormState);
      // if passing PONumber
      // getPODetails(value, "",setFormState)
      // form dummy data
      // getPODetails(setFormState)
    }
  };
  const showVendorCodeForImport = () => {
    let show = selectedRole?.roleName === "Import" ? true : false;
    if (
      selectedRole?.roleName === "Import" &&
      formState.demandType === "Spare Parts"
    ) {
      show = false;
    }
    if (
      selectedRole?.roleName === "Import" &&
      formState.demandType === "Material"
    ) {
      show = false;
    }
    if (
      selectedRole?.roleName === "Import" &&
      formState.demandType === "Samples"
    ) {
      show = false;
    }
    return show;
  };
  const roleHandler = (newValue) => {
    setFormState((formState) => ({
      ...formState,
      isInitiator: newValue.roleName === "I2P Initiator" ? true : false,
      isHR: newValue.roleName === "HR" ? true : false,
      isPCDV: newValue.roleName === "EFDV Initiator" ? true : false,
      isImport: newValue.roleName === "Import" ? true : false,
      isLogistics: newValue.roleName === "Logistic" ? true : false,
    }));

    setSelectedRole(newValue);
  };
  const submitHandler = (e) => {
    //

    e.preventDefault();
    setConfirmationModal(true);
    setConfirmationMessage("Are you sure to proceed the Invoice ");
    // updateIPInvoice(
    //   newFormState,
    //   setNewFormState,
    //   poBasedState,
    //   setErrorMessage,
    //   setSuccessMessage,
    //   setAttachInvoiceLoading,
    //   navigate
    // );
  };
  const [dataLoading, setDataLoading] = useState(false);

  useEffect(() => {
    getRefrenceDataList(
      "invoiceType",
      "invoice_Type",
      () => {},
      setMultipleData
    );
    if (invoicePayload && role) {
      // getInvoiceByInvoiceIdAndRoleId(invoicePayload, role, setFormState);
      GetBatchInvoiceDetailsWithname(
        () => {},
        () => {},
        setMultipleData,
        invoicePayload,
        role,
        setFormState,
        setDataLoading,
        setPoBasedState
      );
      getCommentsByInvoiceId(
        setCommentsList,
        setCommentsLoading,
        invoicePayload?.Invoice_id
      );
      // getAllInvoiceDetailByInvoiceId(
      //   setFormState,
      //   setMultipleData,
      //   invoicePayload?.Invoice_id,
      //   () => {},
      //   () => {},
      //   "",
      //   () => {}
      // );
      vendorTaxDetailForCnic(setFormState, invoicePayload?.Vendor_Code);
    }
    getRefrenceDataList(
      "PaymentTerm",
      "paymentTerms",
      setFormState,
      setMultipleData
    );
    getRefrenceDataList(
      "PaymentMethod",
      "paymentMethod",
      setFormState,
      setMultipleData
    );
    getRefrenceDataList(
      "PaymentMethodSupp",
      "paymentMethSupp",
      setFormState,
      setMultipleData
    );
    getUserRoles(setRoles, setRolesLoading);
  }, []);
  useEffect(() => {
    if (formState?.invoice_Accounts_list?.length > 0) {
      let temp = [];
      for (let i = 0; i < formState?.invoice_Accounts_list?.length; i++) {
        const item = formState?.invoice_Accounts_list[i];
        const obj = {
          accountId: 0,
          invoice_Id: Number(invoicePayload?.Invoice_id),
          expenseDate: item?.expenseDate?.slice(0, -9),

          glAccount: item?.GLAccount,
          costCenter: item?.CostCenter,
          // costCenter: { CostCenterCode: item?.CostCenter || "" },
          costCenterOwner: item?.CostCenterOwner,
          accountType: item?.accountType,
          costCenterOwnerName: item?.CostCenterOwnerName,
          wbsElement: item?.WBSElement,
          horizonId: item?.HorizonId,
          vendorCode: item?.VendorCode,
          amount: Number(item?.Amount),
          profitCenter: Number(item?.ProfitCenter),
          department: item?.Department,
          description: item?.Description || "",
          tType: item?.TType || "",
          fixedAsset: item?.FixedAsset || "",
        };
        temp.push(obj);
      }
      setNewFormState((formState) => ({
        ...formState,
        invoice_Accounts_list: temp,
        Expense_Accounts_list: temp,
      }));
    }
  }, [formState]);
  return (
    <Card>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={dataLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <CardHeader color="primary" text>
        <CardText
          style={{
            padding: "0px 27px",
            backgroundColor: "#031C30",
            color: "white",
          }}
        >
          <Grid container justifyContent="space-between">
            <Grid item xs={2} sm={3} md={3} lg={6}>
              <h1 style={{ fontSize: "24px" }}>Loam Approver</h1>
            </Grid>
            <Grid item xs={6} sm={6} md={6} lg={6}>
              <IconButton
                variant="contained"
                style={{ float: "right", marginTop: "1.5%" }}
                onClick={() => navigate("/home")}
              >
                <ArrowBack style={{ color: "#fff" }} titleAccess="Go Back" />
              </IconButton>
            </Grid>
          </Grid>
        </CardText>
      </CardHeader>
      <CardBody>
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={attachInvoiceLoading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        <Grid container style={{ marginTop: "1px", padding: "0px 5px" }}>
          <Grid item xs={12} sm={12} md={12} lg={6}>
            {/* Submitter role */}
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <Typography style={{ color: "black" }}>
                Submitter Role:
              </Typography>
              <Autocomplete
                sx={{
                  "& .MuiInputBase-root": {
                    height: "30px",
                    textAlign: "center",
                    display: "flex",
                    alignItems: "center",
                  },
                  "& .MuiInputBase-input": {
                    marginTop: "-4px", // Adjust this value to move the text up
                    fontSize: 15,
                  },
                }}
                id="submitter_role"
                options={roles}
                size="small"
                value={selectedRole}
                getOptionLabel={(option) =>
                  (option !== "" && `${option?.roleName}`) || ""
                }
                loading={rolesLoading}
                onChange={(event, newValue) => {
                  roleHandler(newValue);
                }}
                disabled
                renderInput={(params) => (
                  <TextField {...params} type="text" name="" required />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={9} lg={9} mt={1}></Grid>
            {!formState.isDeptCordinator ||
              (!formState.isImport && (
                <InvoiceCheckboxes
                  formState={formState}
                  setFormState={setFormState}
                  selectedRole="Loam Approver"
                  disabled={true}
                />
              ))}
            <Grid item xs={12} sm={12} md={12} lg={12}>
              {!formState.isImport && (
                <InvoiceRadioButtons
                  formState={formState}
                  setFormState={setFormState}
                  selectedRole="Loam Approver"
                  physicalOrEInvoice={physicalOrEInvoice}
                  poBasedState={poBasedState}
                  alignForAttachment={true}
                />
              )}
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              {/* <InvoiceTextField
              newFormState={formState}
              setNewFormState={setFormState}
              selectedRole="Loam Approver"
              disabled={true}
              poBasedState={poBasedState}
              showVendorAndPO_NumberForImport={showVendorAndPO_NumberForImport}
              showVendorCodeForImport={showVendorCodeForImport}
              invoice_attachmentRef={invoice_attachmentRef}
              additionalAttachmentRef={additionalAttachmentRef}
              setAttachInvoiceLoading={setAttachInvoiceLoading}
              // setAttchmentFile_UI={setAttchmentFile_UI}
              // attachmentFile_UI={attachmentFile_UI}
              physicalOrEInvoice={physicalOrEInvoice}
              changeHandler={changeHandler}
              alignForAttachment={true}
              setAttachmentURLList={setAttachmentURLList}
              attachmentURLList={attachmentURLList}
              setAttachmentURL={setAttachmentURL}
              showAttachmentsHandler={showAttachmentsHandler}
              multipleData={multipleData}
            />*/}
              <InvoiceDetailTextField
                newFormState={formState}
                setNewFormState={setFormState}
                selectedRole="Loam Approver"
                disabled={true}
                poBasedState={poBasedState}
                showVendorAndPO_NumberForImport={
                  showVendorAndPO_NumberForImport
                }
                showVendorCodeForImport={showVendorCodeForImport}
                invoice_attachmentRef={invoice_attachmentRef}
                additionalAttachmentRef={additionalAttachmentRef}
                setAttachInvoiceLoading={setAttachInvoiceLoading}
                // setAttchmentFile_UI={setAttchmentFile_UI}
                // attachmentFile_UI={attachmentFile_UI}
                physicalOrEInvoice={physicalOrEInvoice}
                changeHandler={changeHandler}
                alignForAttachment={true}
                setAttachmentURLList={setAttachmentURLList}
                attachmentURLList={attachmentURLList}
                setAttachmentURL={setAttachmentURL}
                showAttachmentsHandler={showAttachmentsHandler}
                multipleData={multipleData}
              />
            </Grid>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={6}>
            <Typography
              variant="h5"
              component="h2"
              style={{ paddingLeft: "7px" }}
            >
              <Heading title="Attachment Preview" />
            </Typography>

            <AttachmentsCover
              attachmentURLList={attachmentURLList}
              setAttachmentURLList={setAttachmentURLList}
              attachmentURL={attachmentURL}
              setAttachmentURL={setAttachmentURL}
            />
          </Grid>
        </Grid>

        <form onSubmit={submitHandler} style={{ marginTop: "50 px" }}>
          {!formState.isImport && poBasedState === "Non-PO" && (
            <>
              {!formState.skipTaxStep && (
                <>
                  <Heading title="Tax" />
                  {/* <TaxDetail
                    formState={newFormState}
                    setFormState={setNewFormState}
                    invoice_Amount={newFormState.invoice_Amount}
                    disabled={true}
              />*/}
                  <TaxDetailTextField
                    formState={formState}
                    setFormState={setFormState}
                    invoice_Amount={formState.invoice_Amount}
                    edit={"false"}
                  />
                  {formState?.taxCard_List.length > 0 && (
                    <TaxTable
                      formState={formState}
                      setFormState={setFormState}
                      invoice_Amount={formState.invoice_Amount}
                      invoicePayload={invoicePayload}
                      show={true}
                      edit={false}
                      setTaxErrorMsg={() => {}}
                      taxErrorMsg={() => {}}
                    />
                  )}
                </>
              )}
              <span></span>
              {!formState.isImport && !formState?.isPCDV && (
                <>
                  <Typography
                    variant="h4"
                    style={{ margin: "20px 0px 10px 7px" }}
                  >
                    <Heading title="G/L Account" />
                  </Typography>
                  <GL_Table
                    formState={newFormState}
                    setFormState={setNewFormState}
                    show={true}
                    reviwerFlag={true}
                  />
                </>
              )}
              {/* ExpenseTable */}
              {formState?.isPCDV && (
                <Grid
                  container
                  style={{ marginTop: "5px", padding: "0px 5px" }}
                >
                  <Grid item xs={12} sm={12} md={6} lg={12}>
                    <ExpenseTable
                      formState={newFormState}
                      setFormState={setNewFormState}
                      editable={false}
                    />
                  </Grid>
                </Grid>
              )}
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <CommentHistory
                  commentsList={commentsList}
                  commentsLoading={commentsLoading}
                />
              </Grid>
              <Grid container spacing={1} style={{ margin: "20px 0px" }}>
                <Box display="flex" justifyContent={"flex-end"} mt={2}>
                  <Button
                    color="error"
                    variant="contained"
                    type="submit"
                    style={{ display: "none" }}
                    onClick={() =>
                      setFormState({ ...formState, isReject: true })
                    }
                  >
                    Reject
                  </Button>
                  <Button
                    color="secondary"
                    variant="contained"
                    type="submit"
                    style={{ display: "none" }}
                    sx={{ ml: 2 }}
                    onClick={() =>
                      setFormState({ ...formState, isReject: false })
                    }
                  >
                    Approve
                  </Button>
                </Box>
              </Grid>
            </>
          )}
        </form>
      </CardBody>
      {confirmationModal && (
        <ConfirmationModal
          open={confirmationModal}
          close={() => setConfirmationModal(false)}
          message={confirmationMessage}
          submit={() => {
            setAttachInvoiceLoading(true);
            LoamPutInvoice(
              formState,
              setFormState,
              setErrorMessage,
              setSuccessMessage,
              setAttachInvoiceLoading,
              navigate,
              setConfirmationModal
            );
          }}
          loading={attachInvoiceLoading}
        />
      )}

      {openInvoiceGuideLine && (
        <InvoiceGuideLine
          open={openInvoiceGuideLine}
          close={setOpenInvoiceGuideLine}
        />
      )}
      {successMessage && (
        <CustomSnackbar
          open={successMessage !== ""}
          message={successMessage}
          handleClose={() => setSuccessMessage("")}
          variant="success"
        />
      )}
      {errorMessage && (
        <CustomSnackbar
          open={errorMessage !== ""}
          message={errorMessage}
          handleClose={() => setErrorMessage("")}
          variant="error"
        />
      )}
    </Card>
  );
};

export default LoamDetail;
